import { createSlice } from "@reduxjs/toolkit";
import {
  doSubscribe,
  doSendCheckoutId,
  doCancelSubscription,
} from "./subscription.service";

export const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: {
    subscriptionPlan: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Handling send otp action
    builder.addCase(doSubscribe.pending, (state, action) => {
      state.subStatus = "Sending subscription request";
    });
    builder.addCase(doSubscribe.fulfilled, (state, action) => {
      state.paymentUrl = action.payload;
      state.subStatus = "Subscription successful";
    });
    builder.addCase(doSubscribe.rejected, (state, action) => {
      state.subStatus = "Error subscribing";
    });

    // Check if checkout executed
    builder.addCase(doSendCheckoutId.pending, (state, action) => {
      state.statusText = "Sending subscription request";
    });
    builder.addCase(doSendCheckoutId.fulfilled, (state, action) => {
      state.statusText = "Subscription successful";
    });
    builder.addCase(doSendCheckoutId.rejected, (state, action) => {
      state.statusText = "Error subscribing";
    });

    // Cancel subscription
    builder.addCase(doCancelSubscription.pending, (state, action) => {
      state.statusText = "Sending subscription cancel request";
    });
    builder.addCase(doCancelSubscription.fulfilled, (state, action) => {
      state.statusText = "Subscription canceled";
    });
    builder.addCase(doCancelSubscription.rejected, (state, action) => {
      state.statusText = "Error canceling subscription";
    });
  },
});

export default subscriptionSlice.reducer;
